import { render, staticRenderFns } from "./PublicConversationDetails.vue?vue&type=template&id=6b2632ff&scoped=true"
import script from "./PublicConversationDetails.vue?vue&type=script&lang=js"
export * from "./PublicConversationDetails.vue?vue&type=script&lang=js"
import style0 from "./PublicConversationDetails.vue?vue&type=style&index=0&id=6b2632ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2632ff",
  null
  
)

export default component.exports